import React from 'react'

export interface ControlProps {
  checked?: boolean
  disabled?: boolean
}

export enum GroupTheme {
  default = 'DEFAULT',
  button = 'BUTTON',
}

export interface ControlOptionsProps<T = any> extends ControlProps {
  id?: string
  value: T
  title?: string
  defaultChecked?: boolean
  className?: string
  children?: React.ReactNode
  name?: string
  multipleSelect?: boolean
  disabled?: boolean
  dataCy?: string
  tooltipText?: string
}

export interface ControlInputProps<T = any> extends ControlOptionsProps<T> {
  onClick: VoidFunction
  rectangular?: boolean
}

export interface ButtonGroupProps<T> {
  className?: string
  options: Array<ControlOptionsProps<T>>
  name?: string
  title?: string
  multipleSelect?: boolean
  onClick: (value: T) => void
  currentSelection?: T
  dataCy?: string
  rectangular?: boolean
  theme?: GroupTheme
  fullWidth?: boolean
}
